<div class="chat-area">
  <!-- <app-collections *ngIf="showCollections" (backClick)="onBackToChat()"></app-collections> -->
  <app-feedback-admin *ngIf="showFeedbackAdmin" (backClick)="onBackToChat()"></app-feedback-admin>
  <app-visualization *ngIf="showVisualizations" (backClick)="onBackToChat()"></app-visualization>
  <app-inferences *ngIf="showInferences" (backClick)="onBackToChat()"></app-inferences>
  <app-clusters *ngIf="showClusters" (backClick)="onBackToChat()" (inferencesGenerated)="onInferencesGenerated()"></app-clusters>
  <app-members *ngIf="showMembers" (backClick)="onBackToChat()"></app-members>
  <!-- <app-mailbox *ngIf="showMailbox" (backClick)="onBackToChat()"></app-mailbox> -->

  <div [style.display]="(showCollections || showFeedbackAdmin || showVisualizations || showMailbox || showInferences || showClusters || showMembers) ? 'none' : 'flex'"
    style="flex-direction: column; height: 100%;">
    <!-- Full screen loading indicator for chat switching -->
    <div class="chat-loading-fullscreen" *ngIf="isLoading && messages.length === 0">
      <div class="chat-loading-spinner"></div>
    </div>

    <div class="welcome-section" *ngIf="!hasMessages && !isLoading">
      <div class="welcome-content">
        <div class="welcome-logo-badge">
          <img src="assets/logo/spark-icon-transparent.png" alt="Spark" class="welcome-logo">
        </div>
        <h1 class="welcome-title">Welcome to Spark</h1>
        <p class="welcome-message">Hi! I'm here to help.<br>Type your question or pick a quick option below to get
          started.</p>

        <div class="suggested-questions">
          <app-question-card *ngFor="let question of suggestedQuestions" [question]="question" icon="fas fa-question"
            (cardClick)="selectQuestion($event)">
          </app-question-card>
        </div>
      </div>
    </div>

    <div class="messages-container" *ngIf="hasMessages" #messagesContainer (scroll)="onMessagesScroll()">
      <div class="message" *ngFor="let message of messages" [class.user-message]="message.isUser"
        [class.assistant-message]="!message.isUser" [attr.data-message-id]="message.id ">
        <div class="message-content">
          <div class="message-avatar" *ngIf="!message.isUser">
            <img src="assets/logo/spark-icon-transparent.png" alt="Assistant">
          </div>
          <div class="message-text-container">
            <div class="message-text" [class.has-events-only]="message.events?.length && !message.text"
              [class.has-message-text]="message.text">
              <div class="event-trace" *ngIf="hasTrace(message)">
                <button type="button" class="event-trace-pill" *ngIf="message.eventsCollapsed !== undefined"
                  (click)="toggleEventsCollapsed(message)">
                  <svg class="pill-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 3" />
                  </svg>
                  <span>Thought for {{ totalStepCount(message) }} step{{ totalStepCount(message) === 1 ? '' : 's' }}</span>
                  <svg class="pill-chevron" [class.expanded]="!message.eventsCollapsed" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                <div class="event-trace-steps" *ngIf="message.eventsCollapsed === undefined || !message.eventsCollapsed">

                  <div class="thinking-block" *ngIf="message.plan">
                    <div class="thinking-head">
                      <svg class="thinking-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 18h6M10 22h4M15.09 14c.18-.98.65-1.74 1.41-2.5A6 6 0 1 0 8 11.5c.5.5 1.32 1.5 1.5 2.5" />
                      </svg>
                      <span>Thinking</span>
                      <span class="step-spinner" *ngIf="message.isStreaming && !message.text"></span>
                    </div>
                    <div class="thinking-text" [innerHTML]="formatPlanText(message.plan)"></div>
                  </div>

                  <div class="event-trace-step" *ngFor="let event of message.events; let i = index">
                    <span class="step-marker" [class.done]="isStepDone(message, i)">
                      <svg *ngIf="isStepDone(message, i)" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                      <span *ngIf="!isStepDone(message, i)" class="step-spinner"></span>
                    </span>
                    <span class="step-text">{{ event }}</span>
                  </div>

                  <div class="tool-step" *ngFor="let step of message.toolSteps"
                    [class.expandable]="step.status !== 'running'" [class.expanded]="step.expanded"
                    (click)="toggleToolStepExpanded(step)">
                    <div class="tool-step-head">
                      <svg class="tool-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                      </svg>
                      <span class="tool-step-name">{{ step.toolName }}</span>
                      <span class="step-marker done" *ngIf="step.status === 'done'">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </span>
                      <span class="step-spinner" *ngIf="step.status === 'running'"></span>
                      <span class="tool-step-error-marker" *ngIf="step.status === 'error'">!</span>
                      <svg class="tool-step-chevron" *ngIf="step.status !== 'running'" [class.expanded]="step.expanded"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                    <div class="tool-step-meta" *ngIf="!step.expanded && step.resultSummary">{{ step.resultSummary }}</div>
                    <div class="tool-step-detail" *ngIf="step.expanded">
                      <pre class="tool-step-code" *ngIf="step.arguments">{{ formatToolArguments(step.arguments) }}</pre>
                      <div class="tool-step-meta" *ngIf="step.resultSummary">{{ step.resultSummary }}</div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="plain-thinking" *ngIf="!hasTrace(message) && message.isStreaming && !message.text">
                <span class="think-dot"></span>
                <span class="think-dot"></span>
                <span class="think-dot"></span>
              </div>
              <!-- Stopped-response notice -->
              <div class="stopped-notice" *ngIf="message.isStoppedNotice">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="9" />
                  <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" stroke="none" />
                </svg>
                <span>Response stopped</span>
              </div>
              <!-- Markdown + Images Inline -->
              <app-voice-note-player *ngIf="message.audioUrl"
                [src]="message.audioUrl"
                [seconds]="message.audioSeconds || 0"
                [waveform]="message.waveform || []">
              </app-voice-note-player>
              <div class="voice-transcript-pending" *ngIf="message.pendingTranscript && !message.text">
                {{ voiceLabels.voiceTranscribing }}
              </div>
              <div class="markdown-content" *ngIf="!message.isStoppedNotice && message.text" [innerHTML]="message.text | markdown"
                (click)="onContentClick($event)">
              </div>
            </div>
            <div class="assistant-message-actions" *ngIf="!message.isUser && !message.isStreaming">
              <button class="assistant-action-btn" title="Feedback" (click)="onOpenFeedback(message.id)">
                <img src="assets/icons/feedback-icon.svg" alt="Feedback" class="assistant-action-icon">
              </button>
              <button class="assistant-action-btn" title="Copy response" (click)="onCopyResponse(message.text)">
                <img src="assets/icons/copy-icon.svg" alt="Copy" class="assistant-action-icon">
              </button>
              <button class="assistant-action-btn" title="Download image" *ngIf="message.images && message.images.length > 0"
                (click)="onDownloadMessageImages(message)">
                <img src="assets/icons/download-button.svg" alt="Download" class="assistant-action-icon download-action-icon">
              </button>
              <div class="sources-dropdown-wrapper" *ngIf="message.sources && message.sources.length > 0">

                <!-- Pill trigger -->
                <button class="sources-pill-btn" (click)="toggleSourcesDropdown(message.id, $event)">
                  <span class="sources-pill-icon">📄</span>
                  <span class="sources-pill-text">
                    sources
                  </span>
                  <span class="sources-pill-caret">
                    ▼
                  </span>
                </button>
                <!-- Dropdown -->
                <div class="sources-popover" *ngIf="openSourcesMessageId === message.id"
                  (click)="$event.stopPropagation()">
                  <div class="sources-popover-item" *ngFor="let source of message.sources">
                    <span class="doc-icon">📄</span>
                    <span class="doc-title" [title]="source">
                      {{ source }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!message.isUser && showFeedbackCard && feedbackMessageId === message.id"
              class="feedback-card-container feedback-card-wrapper">
              <app-feedback-card [isVisible]="true" [feedbackType]="feedbackType"
                (feedbackSubmitted)="onFeedbackSubmitted($event)" (feedbackClosed)="onFeedbackClosed()"
                (feedbackSuccess)="onFeedbackSuccess()">
              </app-feedback-card>
            </div>

          </div>
        </div>
      </div>

      <!-- Loading indicator for AI response -->
      <!-- <div class="message assistant-message" *ngIf="isLoading">
        <div class="message-content">
          <div class="message-avatar">
            <img src="assets/icons/Assistant-avatar.svg" alt="Assistant" class="assistant-avatar-icon">
          </div>
          <div class="message-text-container">
            <div class="message-text">
              <div class="typing-indicator">
                {{ currentThinkingMessage }}
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Scroll to bottom button -->
    <button *ngIf="showScrollToBottom" class="scroll-to-bottom-btn" type="button" aria-label="Scroll to latest message"
      (click)="scrollToBottom()">
      <img src="assets/icons/scroll-down.svg" alt="Scroll to bottom" class="scroll-to-bottom-icon">
    </button>

    <div *ngIf="showNotificationBar" class="notification-bar"
      [class.success-notification]="notificationType === 'success'" [class.collapsed]="isSidebarCollapsed">
      <div *ngIf="showWarningMessage">
        <img src="assets/images/warning-sign.svg" alt="Warning Sign">
      </div>
      <span id="notification-text">
        {{ notificationMessage }}
      </span>
      <button *ngIf="showWarningMessage" class="notification-dismiss-btn" (click)="dismissNotificationBar()"
        aria-label="Dismiss notification">
        &times;
      </button>
    </div>
    <div class="chat-input-container">
      <div class="chat-input-wrapper">
        <button *ngIf="!isRecording" type="button" class="mic-btn"
          [disabled]="isLoading || isUploadingVoice"
          (click)="startVoiceRecording()"
          [attr.aria-label]="voiceLabels.voiceNoteAria">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v5a3 3 0 0 0 3 3z" />
            <path d="M17 11a1 1 0 1 0-2 0 3 3 0 0 1-6 0 1 1 0 1 0-2 0 5 5 0 0 0 4 4.9V19H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-3.1A5 5 0 0 0 17 11z" />
          </svg>
        </button>
        <textarea *ngIf="!isRecording" class="chat-input"
          [placeholder]="isLoading ? 'Type your next message…' : 'What can I do for you....'"
          [(ngModel)]="currentMessage" (input)="onInput()" (keydown)="onKeyDown($event)"
          #messageInput>
        </textarea>
        <div *ngIf="isRecording" class="voice-recorder">
          <button type="button" class="mic-btn" (click)="cancelVoiceRecording()"
            [attr.aria-label]="voiceLabels.voiceCancelAria">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z" />
            </svg>
          </button>
          <div class="voice-live-wave" aria-hidden="true">
            <span *ngFor="let bar of liveBars" class="voice-live-bar" [style.height.px]="liveBarHeight(bar)"></span>
          </div>
          <span class="voice-live-clock">{{ recordClock }}</span>
        </div>
        <button class="send-btn" [class.is-stop]="isLoading && !isRecording"
          (click)="isRecording ? sendVoiceRecording() : (isLoading ? stopGenerating() : sendMessage())"
          [disabled]="isUploadingVoice || (!isRecording && !isLoading && !currentMessage.trim())"
          [attr.aria-label]="isRecording ? voiceLabels.voiceStopAria : (isLoading ? 'Stop generating' : 'Send message')">
          <img *ngIf="!isLoading || isRecording" src="assets/icons/send-chat-icon.svg" alt="Send" class="send-icon">
          <span *ngIf="isLoading && !isRecording" class="stop-icon" aria-hidden="true"></span>
        </button>
      </div>
      <p *ngIf="voiceError" class="voice-note-error">{{ voiceError }}</p>
      <p class="disclaimer">This chatbot is powered by Brain, our AI reasoning engine, and responses may contain
        errors or inaccuracies.<br> Please verify important information before relying on it.</p>
    </div>
  </div>
</div>
<div *ngIf="previewImage" class="preview-overlay" (click)="closePreview()">
  <div class="preview-header">
    <button class="icon-btn" (click)="closePreview()">
      <img src="assets/icons/close-icon.svg" alt="Close" class="icon-img" />
    </button>
  </div>
  <img [src]="previewImage" class="preview-image">
</div>

<app-img-popup [imageUrl]="selectedImage" (close)="selectedImage = null">
</app-img-popup>